import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { Stage } from '../../enums/stage.enum';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    standalone: true,
    imports: [TranslateModule],
    host: {
        class: `w-full h-[30px] fixed z-[999] top-0 flex items-center justify-center text-sm`,
        '[style.color]': 'fgColor',
        '[style.backgroundColor]': 'bgColor'
    }
})
export class BannerComponent implements OnInit {
    public readonly stage: Stage = environment.stage;

    protected bgColor = '#ffffff';
    protected fgColor = '#20883A';

    private readonly stageColors: Map<Stage, { fg: string; bg: string }> = new Map([
        [Stage.LOCAL, { fg: '#ffffff', bg: '#20883A' }], // Green
        [Stage.DEV, { fg: '#ffffff', bg: '#018484' }], // Teal
        [Stage.QA, { fg: '#000000', bg: '#FBBF28' }], // OrangeRed
        [Stage.TEST, { fg: '#000000', bg: '#1E90FF' }], // DodgerBlue
        [Stage.PROD, { fg: '#ffffff', bg: '#E32B26' }] // Red
    ]);

    public ngOnInit(): void {
        this.initializeBannerColors();
    }

    private initializeBannerColors(): void {
        // Get colors from map with fallback to initial values
        const { fg, bg } = this.stageColors.get(this.stage) ?? {
            fg: this.fgColor,
            bg: this.bgColor
        };
        // Set colors
        this.fgColor = fg;
        this.bgColor = bg;
    }
}
